import React from 'react';
import { cn } from '@/utils/styles';
import { Image } from '@design-system/Image';
import { isHexColor } from '@utils/checkHexCode';
import { ProgressBar } from '@design-system/ProgressBar';

interface ScoreCardProps {
  score: number;
  title: string;
  tag: string;
  color: string;
  hasProgressBar?: boolean;
  icon?: string;
  variant?: 'light' | 'dark';
  onClick?: () => void;
}

export const ScoreCard: React.FC<ScoreCardProps> = ({
  score,
  title,
  tag,
  color,
  icon,
  hasProgressBar,
  variant = 'light',
  onClick,
}) => {
  return (
    <button
      onClick={onClick}
      className={cn(
        'rounded-lg p-4 flex items-center justify-between transition-transform transform focus:outline-none min-w-60 w-full min-h-20 gap-4 bg-background shadow-sm',
        variant,
      )}
    >
      {/* Icon */}
      {icon && (
        <div className="w-10 h-10 bg-transparent flex items-center justify-center">
          <Image
            src={icon}
            alt={`${title} icon`}
            width={40}
            height={40}
            className="object-contain"
          />
        </div>
      )}

      {/* Text Content */}
      <div className="flex flex-col flex-grow">
        <div className="flex flex-grow w-full">
          <div className="flex flex-col flex-grow w-3/4">
            <h3
              className={cn(
                ' typography-title text-left text-primary break-all line-clamp-1',
                variant,
              )}
            >
              {title}
            </h3>
            <p
              className={cn(
                'typography-body text-left pt-2',
                !isHexColor(color) && color,
              )}
              style={isHexColor(color) ? { color } : undefined}
            >
              {tag}
            </p>
          </div>
          <span
            className={cn(
              'typography-num-100 flex-shrink-0 text-tertiary w-1/4 flex justify-end',
              variant,
            )}
          >
            {score}
          </span>
        </div>

        {hasProgressBar && (
          <div className="mt-4">
            <ProgressBar progress={score} color={color} />
          </div>
        )}
      </div>
    </button>
  );
};
